import axios from 'axios';
import { message } from 'ant-design-vue';
import { generateSignHeaders, mapSignErrorMsg } from '@/utils/sign';
import { encryptBody, ENABLE_CRYPTO } from '@/utils/encrypt';
// 创建 axios 实例
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://api.example.com', // API 基础路径
    timeout: 10000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器
apiClient.interceptors.request.use(
    config => {
        config.headers['token'] = localStorage.getItem("token");
        config.headers['tenantId'] = 1;
        // 追加签名头（每次请求现场生成）
        const signHeaders = generateSignHeaders();
        Object.keys(signHeaders).forEach(k => {
            config.headers[k] = signHeaders[k];
        });
        // 请求体加密：仅加密非 GET、非 FormData、非 URLSearchParams 的 JSON 请求
        const method = (config.method || 'get').toLowerCase();
        const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
        const isUrlSearchParams = typeof URLSearchParams !== 'undefined' && config.data instanceof URLSearchParams;
        if (ENABLE_CRYPTO && method !== 'get' && !isFormData && !isUrlSearchParams) {
            let payload = config.data;
            // 业务代码可能已手动 JSON.stringify，先转回对象避免双重序列化
            if (typeof payload === 'string') {
                try {
                    payload = JSON.parse(payload);
                } catch (e) {
                    // 非 JSON 字符串则保持原样
                }
            }
            // 无参数时也加密空对象 {}，不发送空 body
            config.data = encryptBody(payload || {});
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    error => {
        // 请求错误时的处理
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
apiClient.interceptors.response.use(
    response => {
        // 对响应数据进行处理
        switch (response.data.code) {
            case 401:
                // 处理未授权错误，如跳转到登录页面
                message.error(' 请登录!');
                window.localStorage.clear();
                window.location.href = '/login'
                return response.data;
            case 403:
                //缺少权限
                window.location.href = '/error?code=' + response.data.code + "&msg=" + response.data.msg;
                return response.data;
            case 601:
                //用户锁定
                window.location.href = '/error?code=' + response.data.code + "&msg=" + response.data.msg;
                window.localStorage.clear();
                return response.data;
            case 500: {
                // 调用方自行处理错误提示时（如登录携带滑块凭证），跳过统一提示
                if (response.config && response.config.silent) {
                    return response.data;
                }
                // 处理服务器错误（签名校验类错误优先映射为友好提示）
                const signTip = mapSignErrorMsg(response.data.msg);
                if (signTip) {
                    message.error(signTip);
                } else {
                    message.error(response.data.code + ' 请求错误：' + response.data.msg);
                }
                return response.data;
            }
            default:
                return response.data;
        }
    },
    error => {
        let result = {'data':{'code':'500'}};
        // 处理响应错误
        if (error.response) {
            message.error('请求错误：' + error.code);
        } else if (error.request) {
            message.error('网络异常: '+error.code);
        } else {
            message.error('意外的错误：' + error.code);
        }
        // return Promise.reject(error);
        return result;
    }
);
// API 请求函数

//登录（config 可传 { silent: true } 跳过统一错误提示，由调用方自行处理）
export function loginUser(data, config) {
    return apiClient.post('doLogin', data, config);
}



//验证登录是否有效
export function checkToken() {
    return apiClient.get('checkToken');
}

//用户退出登录
export function logOut() {
    return apiClient.get('logOut');
}